/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Input } from '@atoms';
import { Form } from '@organisms';

const getComponent = ({ multiline, password }) => {
  if (multiline && password) throw new Error(`Can't use multiline and password simultaneously on TextField`);
  if (multiline) return Input.TextArea;
  if (password) return Input.Password;
  return Input;
};

const TextField = ({ placeholder, disabled, rows = 4, password, multiline, inputStyles = {}, ...props }) => {
  const Component = getComponent({ password, multiline });
  return (
    <Form.Item {...props}>
      <Component placeholder={placeholder} disabled={disabled} rows={rows} style={inputStyles} />
    </Form.Item>
  );
};

export default TextField;
